// import React, { useState, useEffect } from "react";
// import { useHistory } from 'react-router-dom';
// import { connect } from "react-redux";
// import axios from "axios";
// import { NavLink } from "react-bootstrap";
// import ConfirmDeleteModal from './ConfirmationModelDelete';

// const CategoryEvents = () => {
//   const [categories, setCategories] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [showModal, setShowModal] = useState(false);
//   const [selectedCategoryId, setSelectedCategoryId] = useState(null);
//   const history = useHistory();
//   const token = localStorage.getItem('authToken');
//   const getData = async () => {
//     try {
//       const response = await axios.get(`https://samaj.aasmo.in/api/admin/eventscategory?page=${currentPage}&search=${searchQuery}`, {
//         headers: {
//           Authorization: `Bearer ${token}`, 
//         },
//       });
//       setCategories(response.data.categories);
//       setTotalPages(response.data.totalPages);
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   const handleEdit = (id) => {
//     history.push(`/editeventscategory/${id}`);
//   };

//   const handleDelete = async (id) => {
//     try {
//       const response = await axios.delete(`https://samaj.aasmo.in/api/admin/eventscategory/${id}`,{
//         headers: {
//           Authorization: `Bearer ${token}`, 
//         },
//       });
//       if (response) {
//         console.log("Deleted Successfully");
//         getData();
//       }
//     } catch (error) {
//       console.log(error);
//     }
//     setShowModal(false);
//   };

//   const handleDeleteClick = (id) => {
//     setSelectedCategoryId(id);
//     setShowModal(true);
//   };

//   useEffect(() => {
//     getData();
//   }, [currentPage, searchQuery]);

//   const handlePageChange = (page) => {
//     setCurrentPage(page);
//   };

//   const handleSearch = (e) => {
//     setSearchQuery(e.target.value);
//   };

//   return (
//     <div className="col-lg-12">
//       <div className="card">
//         <div className="header">
//           <h2>Events Category List</h2>
//         </div>
//         <div className="d-flex justify-content-between">
//           <div className="input-group m-b-10 col-lg-3">
//             <div className="input-group-prepend">
//               <span className="input-group-text">
//                 <i className="icon-magnifier"></i>
//               </span>
//             </div>
//             <input
//               type="text"
//               className="form-control"
//               placeholder="Search By Category Name"
//               value={searchQuery}
//               onChange={handleSearch}
//             />
//           </div>
//         </div>
//         <div className="body table-responsive">
//           <table className="table table-hover">
//             <thead>
//               <tr>
//                 <th>S.No</th>
//                 <th>Category Name</th>
//                 <th>Category Image</th>
//                 <th>Action</th>
//               </tr>
//             </thead>
//             <tbody>
//   {categories.map((category, index) => {
//     const imageUrl = `https://uma-classees.blr1.digitaloceanspaces.com/${category.image}`;
//     return (
//       <tr key={category.id}>
//         <td>{(currentPage - 1) * 10 + index + 1}</td>
//         <td>{category.name}</td>
//         <td>
//           <img src={imageUrl} height="50px" width="60px" className="user-photo" alt="Category" />
//         </td>
//         <td>
//           <i className="icon-pencil" onClick={() => handleEdit(category.id)}></i>
//           &nbsp;&nbsp;
//           <i className="fa fa-trash-o" onClick={() => handleDeleteClick(category.id)}></i>
//         </td>
//       </tr>
//     );
//   })}
// </tbody>
//           </table>
//         </div>
//         <div className="body">
//           <nav aria-label="Page navigation example" style={{ display: 'flex', justifyContent: 'center' }}>
//             <ul className="pagination">
//               <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
//                 <NavLink
//                   to="#"
//                   className="page-link"
//                   onClick={() => handlePageChange(currentPage - 1)}
//                 >
//                   Previous
//                 </NavLink>
//               </li>
//               {[...Array(totalPages).keys()].map(page => (
//                 <li key={page} className={`page-item ${currentPage === page + 1 ? 'active' : ''}`}>
//                   <NavLink
//                     to="#"
//                     className="page-link"
//                     onClick={() => handlePageChange(page + 1)}
//                   >
//                     {page + 1}
//                   </NavLink>
//                 </li>
//               ))}
//               <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
//                 <NavLink
//                   to="#"
//                   className="page-link"
//                   onClick={() => handlePageChange(currentPage + 1)}
//                 >
//                   Next
//                 </NavLink>
//               </li>
//             </ul>
//           </nav>
//         </div>
//       </div>
//       <ConfirmDeleteModal
//         show={showModal}
//         handleClose={() => setShowModal(false)}
//         handleConfirm={() => handleDelete(selectedCategoryId)}
//       />
//     </div>
//   );
// };

// const mapStateToProps = ({ mailInboxReducer }) => ({});

// export default connect(mapStateToProps, {})(CategoryEvents);


import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import axios from "axios";
import { NavLink } from "react-bootstrap";
import ConfirmDeleteModal from './ConfirmationModelDelete';

const CategoryEvents = () => {
  const [categories, setCategories] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const history = useHistory();
  const token = localStorage.getItem('authToken');

  const getData = async () => {
    try {
      const response = await axios.get(`https://samaj.aasmo.in/api/admin/eventscategory?page=${currentPage}&search=${searchQuery}`, {
        headers: {
          Authorization: `Bearer ${token}`, 
        },
      });
      // --- CHANGE 1: Safety check for API response ---
      if (response.data && Array.isArray(response.data.categories)) {
        setCategories(response.data.categories);
        setTotalPages(response.data.totalPages);
      } else {
        setCategories([]);
        setTotalPages(1);
      }
    } catch (error) {
      console.log(error);
      setCategories([]);
      setTotalPages(1);
    }
  };

  const handleEdit = (id) => {
    history.push(`/editeventscategory/${id}`);
  };

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(`https://samaj.aasmo.in/api/admin/eventscategory/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`, 
        },
      });
      if (response) {
        console.log("Deleted Successfully");
        getData();
      }
    } catch (error) {
      console.log(error);
    }
    setShowModal(false);
  };

  const handleDeleteClick = (id) => {
    setSelectedCategoryId(id);
    setShowModal(true);
  };

  useEffect(() => {
    getData();
  }, [currentPage, searchQuery]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSearch = (e) => {
    setCurrentPage(1);
    setSearchQuery(e.target.value);
  };

  return (
    <div className="col-lg-12">
      <div className="card">
        <div className="header">
          <h2>Events Category List</h2>
        </div>
        <div className="d-flex justify-content-between">
          <div className="input-group m-b-10 col-lg-3">
            <div className="input-group-prepend">
              <span className="input-group-text">
                <i className="icon-magnifier"></i>
              </span>
            </div>
            <input
              type="text"
              className="form-control"
              placeholder="Search By Category Name"
              value={searchQuery}
              onChange={handleSearch}
            />
          </div>
        </div>
        <div className="body table-responsive">
          <table className="table table-hover">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Category Name</th>
                <th>Category Image</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {/* --- CHANGE 2: Safety check for rendering --- */}
              {Array.isArray(categories) && categories.map((category, index) => (
                <tr key={category.id}>
                  <td>{(currentPage - 1) * 10 + index + 1}</td>
                  <td>{category.name}</td>
                  <td>
                    {/* --- CHANGE 3: Use the full URL directly from the API --- */}
                    <img src={category.image} height="50px" width="60px" className="user-photo" alt="Category" />
                  </td>
                  <td>
                    <i className="icon-pencil" onClick={() => handleEdit(category.id)}></i>
                      
                    <i className="fa fa-trash-o" onClick={() => handleDeleteClick(category.id)}></i>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="body">
          <nav aria-label="Page navigation example" style={{ display: 'flex', justifyContent: 'center' }}>
            <ul className="pagination">
              <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                <NavLink to="#" className="page-link" onClick={() => handlePageChange(currentPage - 1)}>Previous</NavLink>
              </li>
              {[...Array(totalPages).keys()].map(page => (
                <li key={page} className={`page-item ${currentPage === page + 1 ? 'active' : ''}`}>
                  <NavLink to="#" className="page-link" onClick={() => handlePageChange(page + 1)}>{page + 1}</NavLink>
                </li>
              ))}
              <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                <NavLink to="#" className="page-link" onClick={() => handlePageChange(currentPage + 1)}>Next</NavLink>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <ConfirmDeleteModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        handleConfirm={() => handleDelete(selectedCategoryId)}
      />
    </div>
  );
};

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default connect(mapStateToProps, {})(CategoryEvents);